module.exports = __webpack_public_path__ + "static/nav-f113fd407b48ad80a038a9188121f62d.png";